import React, { Component} from 'react';

import { Select, Form } from 'antd';

import service from './../../services';

const FormItem = Form.Item;
const Option = Select.Option;

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            data: [],
            maps: {}
        };
    }

    componentDidMount() {
        this.querySearch();
    }

    querySearch() {
        return service.course.querySearchType()
        .then((data) => {
            const values = data.map(d => d.value);
            const maps = {};

            data.forEach(d => {
                maps[d.value] = d.label;
            });

            // if(!this.props.value) {
            //     const value = values[0];
            //     this.setState({
            //         value: values[0]
            //     });
            //     const name = this.props.name;

            //     this.props.handleChange({
            //         [name]: this.state.maps[value]
            //     });
            // }

            this.setState({
                data: values,
                maps
            });

            
        });
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value,
            });
        }
    }

    handleChange(value) {
        const name = this.props.name;
        
        this.setState({
            value: value
        });

        if(this.props.handleChange) {
            this.props.handleChange({
                codeValue : value,
                [name]: this.state.maps[value]
            });
        }
    }

    render() {
        const { label, style, actionDisable } = this.props;
        const { value, data, maps } = this.state;
        return (
            <FormItem label={label || "课程类别"}>
                <Select
                disabled={actionDisable}
                value={value}
                style={style || { width: 240 }}
                allowClear={true}
                dropdownMatchSelectWidth={false}
                placeholder="请输入..."
                onChange={(value) => {
                    this.handleChange(value);
                }}>
                {
                    data.map((value) => (
                        <Option value={value}>{maps[value]}</Option>
                    ))
                }
                </Select>
            </FormItem>
        );
    }
}